import { useEffect, useState } from 'react';
import { Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import handleCTAClick from '../../../services/helpers/handleCTAClick';
import styles from './ratesTableList.module.scss';

export default function RatesTableList({
  data = [],
  ctaLabel = '',
  type = null,
  cta,
}) {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    data.forEach((item) => {
      if (item.selected) {
        setSelectedItem(item.url);
      }
    });
  }, [data]);

  const tableContent = (item) => (
    <div
      className={`${styles.box} ${
        selectedItem === item.url ? styles.selectedBox : ''
      } ${type ? styles[type] : ''}`}
      onClick={() => setSelectedItem(item.url)}
      onKeyDown={() => setSelectedItem(item.url)}
      role="button"
      tabIndex="0"
    >
      <input
        type="radio"
        id={item.title}
        name="url"
        className={styles.radio}
        value={item.url}
        checked={selectedItem === item.url}
        onChange={() => setSelectedItem(item.url)}
      />
      <h3 className={styles.itemTitle} data-testid={item.title}>
        {parse(item.title)}
      </h3>
      <p className={styles.period}>{parse(item.description)}</p>
    </div>
  );

  const rows = [];
  const itemsPerRow = 3; // Set items per row to 3
  for (let i = 0; i < data.length; i += itemsPerRow) {
    const cols = data.slice(i, i + itemsPerRow).map((item) => (
      <Grid
        data-testid="grid-section"
        item
        xs={12}
        sm={12 / itemsPerRow}
        md={12 / itemsPerRow}
        lg={12 / itemsPerRow}
        key={`${item.title}${item.description}`}
      >
        {tableContent(item)}
      </Grid>
    ));
    rows.push(cols);
  }

  return (
    <>
      <Grid container spacing={3} className={styles.wrapper}>
        {rows}
      </Grid>
      {(ctaLabel || cta?.label) && (
        <Grid
          item
          container
          xs={12}
          justifyContent={type === 'card' ? 'flex-end' : 'center'}
        >
          <CtaButton
            className={styles.cta}
            label={ctaLabel || cta?.label}
            variant={cta?.variant}
            color={cta?.color}
            href={selectedItem ?? '#'}
            onClick={(e) => handleCTAClick(e, { link: selectedItem ?? '#' })}
          />
        </Grid>
      )}
    </>
  );
}

RatesTableList.propTypes = {
  data: PropTypes.array,
  ctaLabel: PropTypes.string,
  type: PropTypes.oneOf([null, 'card']),
};
